{
  "name": "@udecode/plate-ui",
  "version": "34.0.2",
  "description": "Add Plate components to your apps.",
  "keywords": [
    "components",
    "plate",
    "slate",
    "ui",
    "tailwind",
    "radix-ui",
    "shadcn"
  ],
  "homepage": "https://platejs.org",
  "bugs": {
    "url": "https://github.com/udecode/plate/issues"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/udecode/plate.git",
    "directory": "packages/cli"
  },
  "license": "MIT",
  "sideEffects": false,
  "type": "module",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "module": "./dist/index.mjs",
      "require": "./dist/index.js"
    }
  },
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "bin": "./dist/index.js",
  "files": [
    "dist/**/*"
  ],
  "scripts": {
    "build": "yarn tsup",
    "build:watch": "yarn tsup --watch",
    "clean": "yarn p:clean && rimraf components",
    "dev": "COMPONENTS_REGISTRY_URL=http://localhost:3000 node dist/index.js",
    "lint": "yarn p:lint",
    "lint:fix": "yarn p:lint:fix",
    "start": "node dist/index.js",
    "test": "vitest run",
    "test:watch": "yarn p:test:watch",
    "typecheck": "yarn p:typecheck"
  },
  "dependencies": {
    "@antfu/ni": "^0.21.4",
    "@babel/core": "^7.22.1",
    "@babel/parser": "^7.22.6",
    "@babel/plugin-transform-typescript": "^7.22.5",
    "commander": "^10.0.0",
    "cosmiconfig": "^8.1.3",
    "deepmerge": "^4.3.1",
    "diff": "^5.1.0",
    "execa": "^7.0.0",
    "fast-glob": "^3.3.2",
    "fs-extra": "^11.1.0",
    "https-proxy-agent": "^6.2.0",
    "kleur": "^4.1.5",
    "lodash.template": "^4.5.0",
    "node-fetch": "^3.3.0",
    "ora": "^6.1.2",
    "postcss": "^8.4.24",
    "prompts": "^2.4.2",
    "recast": "^0.23.2",
    "stringify-object": "^5.0.0",
    "ts-morph": "^18.0.0",
    "tsconfig-paths": "^4.2.0",
    "zod": "^3.20.2"
  },
  "devDependencies": {
    "@types/babel__core": "^7.20.1",
    "@types/diff": "^5.0.3",
    "@types/fs-extra": "^11.0.1",
    "@types/lodash.template": "^4.5.1",
    "@types/prompts": "^2.4.2",
    "@types/stringify-object": "^4.0.5",
    "rimraf": "^6.0.1",
    "tsup": "^6.6.3",
    "type-fest": "^3.8.0",
    "typescript": "^4.9.3"
  },
  "publishConfig": {
    "access": "public"
  }
}
